export const openFilePicker = (input: HTMLInputElement | null) => input?.click();
